export const SET_ORDER_DATA = "SET_ORDER_DATA";
export const SET_ORDER_STATUS = "SET_ORDER_STATUS";
export const SET_ORDER_COUNTRY = "SET_ORDER_COUNTRY";
export const RESET_ORDER_STATE = "RESET_ORDER_STATE";
